export const ROOT_NOTIFICATION_STATE = 'notification';

export const INITIAL_STATE = {
  visible: true
};
